<ul class="breadcrumb-list">
  <li class="breadcrumb-list__item crumb type-body-sm fw-normal crumb--back">
    <button class="crumb__link" (click)="goBack()">Terug</button>
  </li>
  @for (crumb of crumbs; track crumb; let i = $index) {
    <li class="breadcrumb-list__item crumb type-body-sm fw-normal">
      @if (i !== crumbs.length - 1) {
        <a class="crumb__link" [routerLink]="crumb.routerLink" [queryParams]="crumb?.params">
          {{ crumb.label }}
        </a>
      }
      @if (i === crumbs.length - 1) {
        <span>{{ crumb.label }}</span>
      }
      @if (i !== crumbs.length - 1) {
        <app-icon class="crumb__seperator icon-xxxs" anchor="icon-chevron-right-xs"></app-icon>
      }
    </li>
  }
</ul>
